import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../Services/apiService";

export const GetTechnicalReportsRequiredByReportGuid = createAsyncThunk(
  "TechnicalReportsRequired/GetTechnicalReportsRequiredByReportGuid",
  async (reportId, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        `api/TechnicalReportsRequired/GetTechnicalReportsRequiredByReportGuid?reportId=${reportId}`,
        {}
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataaaa");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);


export const GetTechnicalReportsRequiredByReportGuidAndName = createAsyncThunk(
    "TechnicalReportsRequired/GetTechnicalReportsRequiredByReportGuidAndName",
    async (model, { rejectWithValue }) => {
      try {
        await initializeApiClient();
        const apiClient = await getApiClient();
        const response = await apiClient.post(
          `api/TechnicalReportsRequired/GetTechnicalReportsRequiredByReportGuidAndName?reportId=${model.reportId}&TableName=${model.TableName}`,
          {}
        );
  
        // Extract data from the response object
        const data = response.data.result; // Assuming response has a "data" field
        //console.log(data, "dataaaa");
  
        return data; // Return the extracted data
      } catch (error) {
        return rejectWithValue(error.message);
      }
    }
  );
export const UpdateTechnicalReportsRequiredByReportGuid = createAsyncThunk(
  "TechnicalReportsRequired/UpdateTechnicalReportsRequiredByReportGuid",
  async (update, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        `api/TechnicalReportsRequired/UpdateTechnicalReportsRequiredByReportGuid?reportId=${update.reportId}&TableName=${update.TableName}&isActive=${update.isActive}`,
        {}
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataproject");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const TechnicalReportsRequired = createSlice({
  name: "TechnicalReportsRequired",
  initialState: {
    TechnicalReportsRequired: [],
    loadingTechnicalReportsRequired: false,
    errorTechnicalReportsRequired: null,
    //----------------------- update -------------------------------------
    UpdateTechnicalReportsRequired: [],
    loadingUpdateTechnicalReportsRequired: false,
    errorUpdateTechnicalReportsRequired: null,
    //-----------------------------------------------------------------------
    TechnicalReportsRequiredName: [],
    loadingTechnicalReportsRequiredName: false,
    errorTechnicalReportsRequiredName: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(
        GetTechnicalReportsRequiredByReportGuid.pending,
        (state, action) => {
          state.loadingTechnicalReportsRequired = true;
          state.TechnicalReportsRequired = action.payload;
          state.errorTechnicalReportsRequired = null;
        }
      )
      .addCase(
        GetTechnicalReportsRequiredByReportGuid.fulfilled,
        (state, action) => {
          state.loadingTechnicalReportsRequired = false;
          state.TechnicalReportsRequired = action.payload; // Assuming payload has the desired data
        }
      )
      .addCase(
        GetTechnicalReportsRequiredByReportGuid.rejected,
        (state, action) => {
          state.loadingTechnicalReportsRequired = false;
          state.TechnicalReportsRequired = action.payload;
        }
      )
      //-------------------------------------- update ---------------------------------------
      .addCase(UpdateTechnicalReportsRequiredByReportGuid.pending, (state, action) => {
        state.loadingUpdateTechnicalReportsRequired = true;
        state.UpdateTechnicalReportsRequired = action.payload;
        state.errorUpdateTechnicalReportsRequired = null;
      })
      .addCase(UpdateTechnicalReportsRequiredByReportGuid.fulfilled, (state, action) => {
        state.loadingUpdateTechnicalReportsRequired = false;
        state.UpdateTechnicalReportsRequired = action.payload; // Assuming payload has the desired data
      })
      .addCase(UpdateTechnicalReportsRequiredByReportGuid.rejected, (state, action) => {
        state.loadingUpdateTechnicalReportsRequired = false;
        state.UpdateTechnicalReportsRequired = action.payload;
      })
      
       //-------------------------------------- name ---------------------------------------
       .addCase(GetTechnicalReportsRequiredByReportGuidAndName.pending, (state, action) => {
        state.loadingTechnicalReportsRequiredName = true;
        state.TechnicalReportsRequiredName = action.payload;
        state.errorTechnicalReportsRequiredName = null;
      })
      .addCase(GetTechnicalReportsRequiredByReportGuidAndName.fulfilled, (state, action) => {
        state.loadingTechnicalReportsRequiredName = false;
        state.TechnicalReportsRequiredName = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetTechnicalReportsRequiredByReportGuidAndName.rejected, (state, action) => {
        state.loadingTechnicalReportsRequiredName = false;
        state.TechnicalReportsRequiredName = action.payload;
      });
  },
});

export default TechnicalReportsRequired.reducer;
